<template>
  <v-container class="pa-1">
    <v-btn small fab color="white" router to="/dashboard">
      <v-icon medium color="red">close</v-icon>
    </v-btn>
    <v-flex xs12 md12>
      <v-text-field
        class="pt-4 pl-3 white"
        v-model="search"
        label="Search member by Name"
        prepend-icon="search"
      ></v-text-field>
    </v-flex>
    <v-layout row>
      <v-flex xs12 md4 class="grey darken-3 white--text pa-2">Name and Website</v-flex>
      <v-flex xs12 md3 class="grey darken-3 white--text pa-2">Primary Contact</v-flex>
      <v-flex xs12 md3 class="grey darken-3 white--text pa-2">Secondary Contact</v-flex>
      <v-flex xs12 md2 class="grey darken-3 white--text pa-2">Actions</v-flex>
    </v-layout>
    <v-divider></v-divider>
    <v-card flat v-for="(person) in membersList" :key="person.id">
      <v-layout v-if="!saved" row wrap>
        <v-flex xs12 md4 class="white pa-2">
          <div class="pa-1">
            <h3 class="teal--text"></h3>
            <h3>{{person.name}}</h3>
            <h5>
              <a :href="person.website" target="_blank">Website: {{person.website}}</a>
            </h5>
          </div>
        </v-flex>
        <v-flex xs12 md3 class="grey lighten-5 pa-2">
          <h5>
            <v-icon>person</v-icon>
            {{person.contactname}}
          </h5>
          <h5>
            <v-icon>phone</v-icon>
            {{person.contactphone}}
          </h5>
          <h5>
            <v-icon>email</v-icon>
            {{person.contactemail}}
          </h5>
        </v-flex>
        <v-flex xs12 md3 class="white pa-2">
          <h5>
            <v-icon>person</v-icon>
            {{person.contactname1}}
          </h5>
          <h5>
            <v-icon>phone</v-icon>
            {{person.contactphone1}}
          </h5>
          <h5>
            <v-icon>email</v-icon>
            {{person.contactemail1}}
          </h5>
        </v-flex>
        <v-flex xs12 md2 class="grey lighten-5 pa-2">
          <v-btn small class="indigo white--text" @click="dialog=true" disabled>Send Email</v-btn>

          <v-dialog v-model="dialog" width="500">
            <v-card class="pa-3">
              Email to: {{person.name}}
              <v-text-field clearable label="Subject" prepend-icon="subject"></v-text-field>
              <v-text-field v-model="person.contactemail" label="Email" prepend-icon="email"></v-text-field>
              <v-textarea outline clearable label="Message" prepend-icon="message"></v-textarea>
              <v-btn color="indigo white--text" @click="sendEmail()">SEND</v-btn>
              <v-btn color="grey lighten-2" @click="dialog=false">CANCEL</v-btn>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-divider class="teal lighten-4"></v-divider>
    </v-card>
  </v-container>
</template>

<script>
import { db, auth, functions } from "@/fb";
export default {
  data() {
    return {
      team: [],
      logo:
        "https://firebasestorage.googleapis.com/v0/b/rimis-sports.appspot.com/o/profileimages%2F",
      link: ".png?alt=media&token=e5b9dc78-e013-44f1-9edf-520fec4f6c94",
      image: "",
      search: "",
      saved: false,
      dialog: false
    };
  },
  methods: {
    sendEmail() {}
  },
  computed: {
    membersList() {
      return this.team.filter(member => {
        return member.name
          .toLowerCase()
          .trim()
          .match(this.search.toLowerCase().trim());
      });
    }
  },
  created() {
    if (auth.currentUser == null) {
      this.$router.push({ name: "home" });
    }
    db.collection("members").onSnapshot(res => {
      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === "added") {
          this.team.push({
            ...change.doc.data(),
            id: change.doc.id
          });
        }
      });
    });
  }
};
</script>